import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import LoaderBanner from '@/components/LoaderBanner'
import { useAuth } from '../lib/auth-context'

export default function AuthCallback() {
  const navigate = useNavigate()
  const location = useLocation()
  const { status } = useAuth()

  const nextPath = useMemo(() => {
    const params = new URLSearchParams(location.search)
    const rawNext = params.get('next') || ''
    if (!rawNext || !rawNext.startsWith('/') || rawNext.startsWith('//')) {
      return '/login'
    }
    return rawNext
  }, [location.search])

  // The official Supabase client (detectSessionInUrl: true) automatically
  // processes the hash tokens. Wait for the auth context to finish loading
  // the session/profile before navigating away.
  useEffect(() => {
    if (status === 'checking' || status === 'idle') return
    navigate(nextPath, { replace: true })
  }, [status, nextPath, navigate])

  return <LoaderBanner text="Signing you in..." />
}
